var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"root"}},[_c('tn-layout',{attrs:{"top-index":1000}},[_c('top-header',{attrs:{"slot":"top"},slot:"top"}),_vm._v(" "),_c('div',{staticClass:"stance-block"}),_vm._v(" "),_c('router-view'),_vm._v(" "),(!this.$root.isFill)?_c('bottom-footer'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68a34b4e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Root.vue
// module id = null
// module chunks = 